import React from "react";
import "./Projects.css";
import Quotes from "./apps/quotes.jpg";
import todo from "./apps/todo.jpg";
import mkm from "./apps/mkm.PNG";
import Flip from "react-reveal/Flip";
import { Zoom } from "react-reveal";

const projects = () => {
  return (
    <>
      <section id="myprojects">
        <h5>My Projects</h5>
        <div className="all">
          <div className="first">
            <div className="image">
              <Zoom>
                <img src={mkm} alt="mikumi" id="quotes"></img>
              </Zoom>
            </div>

            <div className="info">
              <Flip top>
                <p>
                  In this project i used React.js &This is the that employs many
                  react.js areas but also beautiful project for tanzania
                  tourism.
                </p>
              </Flip>
              <a
                href="https://mikumi-africa.web.app/"
                target="_blank"
                rel="noreferrer"
              >
                <button className="download">Visit project</button>
              </a>
            </div>
          </div>
          <div className="second">
            <div className="image">
              <Zoom>
                <img src={Quotes} alt="Todo App" id="todo"></img>
              </Zoom>
            </div>

            <div className="info">
              <Flip top>
                <p>
                  This project used various react.js cases, Also used an API for
                  generating random quotes on each request.
                </p>
              </Flip>

              <a
                href="https://quotes-tz.web.app/"
                target="_blank"
                rel="noreferrer"
              >
                <button className="download">Visit project</button>
              </a>
            </div>
          </div>
          <div className="third">
            <div className="image">
              <Zoom>
                <img src={todo} alt="weather App" id="weather"></img>
              </Zoom>
            </div>
            <div className="info">
              <Flip top>
                <p>
                  This is the project i did for my gleem community as been a
                  member of the community, It was a very nice project because ir
                  employed using CRUD.which is Create,Read,Update and Delete.
                </p>
              </Flip>

              <a
                href="https://todo-8e524.web.app/"
                target="_blank"
                rel="noreferrer"
              >
                <button className="download">Visit project</button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default projects;
